import { useGetMe } from '../api/generated/fluence'
import { idToken, signOut } from '../auth/firebase'

/**
 * Who the session belongs to, and which plan is open.
 *
 * Small, but not decorative. Once a plan can be shared, "whose numbers am I looking at"
 * stops being obvious from the numbers themselves, and a projection read against the wrong
 * plan is indistinguishable from a wrong projection. The plan name appears only when there
 * is more than one it could be.
 */
export function SignedInAs() {
  const { data } = useGetMe()

  // 401 and 403 are documented outcomes, so the generated response is a union and `data`
  // is only a Me on 200 — the same narrowing the projection needs.
  const me = data?.status === 200 ? data.data : undefined
  if (!me) return null

  const activePlan = me.tenants.find((t) => t.id === me.activeTenantId)
  const sharesPlans = me.tenants.length > 1
  // Only when a token is what got us in. In DEV mode there is nothing to sign out of, and
  // offering it would be a button that cannot do anything.
  const canSignOut = idToken() !== null

  async function leave() {
    await signOut()
    // A reload rather than clearing state by hand: the gate re-runs from the top, and
    // every cached query belonging to the person who just left goes with the page.
    window.location.reload()
  }

  return (
    <div className="signed-in">
      <span className="signed-in__who">{me.displayName ?? me.email ?? 'Signed in'}</span>
      {sharesPlans && activePlan && (
        <span className="signed-in__plan" title="The plan these figures belong to">
          {activePlan.name}
        </span>
      )}
      {canSignOut && (
        <button
          type="button"
          className="btn-ghost btn-small signed-in__out"
          onClick={() => void leave()}
        >
          Sign out
        </button>
      )}
    </div>
  )
}
